/** Mensagem padrão de campo obrigatório (antes repetida em cada tela). */
export const REQUIRED_MESSAGE = "Campo obrigatório";

/** Marca visual de campo obrigatório no label (decorativa: `aria-hidden`). */
export const REQUIRED_MARK = "*";
